import Individuals from './Individuals';
export default Individuals;